// @flow
import React from "react";
import easyImagePNG from "../../static/images/upsell-easy.png";
import communicationImagePNG from "../../static/images/upsell-communication.png";
import parkingImagePNG from "../../static/images/upsell-parking.png";
import easyImageWEBP from "../../static/images/upsell-easy.webp";
import communicationImageWEBP from "../../static/images/upsell-communication.webp";
import parkingImageWEBP from "../../static/images/upsell-parking.webp";
import Heading from "../Heading";
import Typography from "../Typography";

import styles from "./appAdvantages.module.scss";

type Props = {
  firstHeading: string,
  firstText: string,
  secondHeading: string,
  secondText: string,
  thirdHeading: string,
  thirdText: string
};

const AppAdvantages = ({
  firstHeading,
  firstText,
  secondHeading,
  secondText,
  thirdHeading,
  thirdText
}: Props) => (
  <ul className={styles.container}>
    <li className={styles.item}>
      <picture>
        <source src={easyImagePNG} />
        <source src={easyImageWEBP} />

        <img
          src={easyImagePNG}
          alt="Lots of spaces"
          width="300px"
          height="190px"
          loading="lazy"
        />
      </picture>

      <Heading bold level={3}>
        {firstHeading}
      </Heading>
      <Typography size="tertiary" color="muted">
        {firstText}
      </Typography>
    </li>

    <li className={styles.item}>
      <picture>
        <source src={communicationImagePNG} />
        <source src={communicationImageWEBP} />

        <img
          src={communicationImagePNG}
          alt="Easy to use"
          loading="lazy"
          width="300px"
          height="190px"
        />
      </picture>

      <Heading bold level={3}>
        {secondHeading}
      </Heading>
      <Typography size="tertiary" color="muted">
        {secondText}
      </Typography>
    </li>

    <li className={styles.item}>
      <picture>
        <source src={parkingImagePNG} />
        <source src={parkingImageWEBP} />

        <img
          src={parkingImagePNG}
          alt="Peace of mind"
          loading="lazy"
          width="300px"
          height="190px"
        />
      </picture>

      <Heading bold level={3}>
        {thirdHeading}
      </Heading>
      <Typography size="tertiary" color="muted">
        {thirdText}
      </Typography>
    </li>
  </ul>
);

export default AppAdvantages;
